import React from 'react';
import * as Icons from '../../icons/tsx/index';

interface IconProps {
  name: string;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  classModifier?: string;
}

const Icon: React.FC<IconProps> = ({ name, size = 'medium', classModifier = '' }) => {
  const getIconComponent = () => {
    switch (name) {
      case 'eye-on':
        return <Icons.IconEyeOn className={`icon icon--${size}`} />;
      case 'eye-off':
        return <Icons.IconEyeOff className={`icon icon--${size}`} />;
      case 'apple-podcast':
        return <Icons.IconApplePodcast className={`icon icon--${size}`} />;
      case 'apple':
        return <Icons.IconApple className={`icon icon--${size}`} />;
      case 'audio-wawe':
        return <Icons.IconAudioWawe className={`icon icon--${size}`} />;
      case 'bookmark':
        return <Icons.IconBookmark className={`icon icon--${size} icon--${classModifier}`} />;
      case 'building':
        return <Icons.IconBuilding className={`icon icon--${size}`} />;
      case 'calendar':
        return <Icons.IconCalendar className={`icon icon--${size}`} />;
      case 'cart':
        return <Icons.IconCart className={`icon icon--${size}`} />;
      case 'chat-bubble':
        return <Icons.IconChatBubble className={`icon icon--${size}`} />;
      case 'chat':
        return <Icons.IconChat className={`icon icon--${size}`} />;
      case 'check':
        return <Icons.IconCheck className={`icon icon--${size}`} />;
      case 'chef':
        return <Icons.IconChef className={`icon icon--${size}`} />;
      case 'circle-add':
        return <Icons.IconCircleAdd className={`icon icon--${size}`} />;
      case 'circle-check':
        return <Icons.IconCircleCheck className={`icon icon--${size}`} />;
      case 'circle-facebook':
        return <Icons.IconCircleFacebook className={`icon icon--${size}`} />;
      case 'circle':
        return <Icons.IconCircle className={`icon icon--${size}`} />;
      case 'clock':
        return <Icons.IconClock className={`icon icon--${size}`} />;
      case 'close':
        return <Icons.IconClose className={`icon icon--${size}`} />;
      case 'cocktail':
        return <Icons.IconCocktail className={`icon icon--${size}`} />;
      case 'copy':
        return <Icons.IconCopy className={`icon icon--${size}`} />;
      case 'play':
        return <Icons.IconPlay className={`icon icon--${size}`} />;
      case 'plus':
        return <Icons.IconPlus className={`icon icon--${size}`} />;
      case 'power':
        return <Icons.IconPower className={`icon icon--${size}`} />;
      case 'quotes':
        return <Icons.IconQuotes className={`icon icon--${size}`} />;
      case 'rectangle':
        return <Icons.IconRectangle className={`icon icon--${size}`} />;
      case 'refresh':
        return <Icons.IconRefresh className={`icon icon--${size}`} />;
      case 'rewind':
        return <Icons.IconRewind className={`icon icon--${size}`} />;
      case 'sale':
        return <Icons.IconSale className={`icon icon--${size}`} />;
      case 'sand':
        return <Icons.IconSand className={`icon icon--${size}`} />;
      case 'search':
        return <Icons.IconSearch className={`icon icon--${size}`} />;
      case 'share':
        return <Icons.IconShare className={`icon icon--${size} `} />;
      case 'shortcut':
        return <Icons.IconShortcut className={`icon icon--${size}`} />;
      case 'spotify':
        return <Icons.IconSpotify className={`icon icon--${size}`} />;
      case 'system-settings':
        return <Icons.IconSystemSettings className={`icon icon--${size}`} />;
      case 'delivery':
        return <Icons.IconDelivery className={`icon icon--${size}`} />;
      case 'diamond-empty':
        return <Icons.IconDiamondEmpty className={`icon icon--${size}`} />;
      case 'diamond-full':
        return <Icons.IconDiamondFull className={`icon icon--${size}`} />;
      case 'document':
        return <Icons.IconDocument className={`icon icon--${size}`} />;
      case 'download':
        return <Icons.IconDownload className={`icon icon--${size}`} />;
      case 'edit':
        return <Icons.IconEdit className={`icon icon--${size}`} />;
      case 'external-link':
        return <Icons.IconExternalLink className={`icon icon--${size}`} />;
      case 'fsquare':
        return <Icons.IconFSquare className={`icon icon--${size}`} />;
      case 'f':
        return <Icons.IconF className={`icon icon--${size}`} />;
      case 'facebook':
        return <Icons.IconFacebook className={`icon icon--${size}`} />;
      case 'figma':
        return <Icons.IconFigma className={`icon icon--${size}`} />;
      case 'folder':
        return <Icons.IconFolder className={`icon icon--${size}`} />;
      case 'font':
        return <Icons.IconFont className={`icon icon--${size}`} />;
      case 'fork-spoon':
        return <Icons.IconForkSpoon className={`icon icon--${size}`} />;
      case 'globe':
        return <Icons.IconGlobe className={`icon icon--${size}`} />;
      case 'google-podcast':
        return <Icons.IconGooglePodcast className={`icon icon--${size}`} />;
      case 'google':
        return <Icons.IconGoogle className={`icon icon--${size}`} />;
      case 'google-play':
        return <Icons.IconGooglePlay className={`icon icon--${size}`} />;
      case 'heart':
        return <Icons.IconHeart className={`icon icon--${size}`} />;
      case 'info':
        return <Icons.IconInfo className={`icon icon--${size}`} />;
      case 'instagram':
        return <Icons.IconInstagram className={`icon icon--${size}`} />;
      case 'invoice':
        return <Icons.IconInvoice className={`icon icon--${size}`} />;
      case 'link':
        return <Icons.IconLink className={`icon icon--${size}`} />;
      case 'linkedin':
        return <Icons.IconLinkedin className={`icon icon--${size}`} />;
      case 'loader':
        return <Icons.IconLoader className={`icon icon--${size}`} />;
      case 'location-pin':
        return <Icons.IconLocationPin className={`icon icon--${size}`} />;
      case 'lock':
        return <Icons.IconLock className={`icon icon--${size}`} />;
      case 'mail-full':
        return <Icons.IconMailFull className={`icon icon--${size}`} />;
      case 'mail':
        return <Icons.IconMail className={`icon icon--${size}`} />;
      case 'menu':
        return <Icons.IconMenu className={`icon icon--${size}`} />;
      case 'mic-mute':
        return <Icons.IconMicMute className={`icon icon--${size}`} />;
      case 'mic':
        return <Icons.IconMic className={`icon icon--${size}`} />;
      case 'minus':
        return <Icons.IconMinus className={`icon icon--${size}`} />;
      case 'moon':
        return <Icons.IconMoon className={`icon icon--${size}`} />;
      case 'notification':
        return <Icons.IconNotification className={`icon icon--${size}`} />;
      case 'overflow-dots':
        return <Icons.IconOverflowDots className={`icon icon--${size}`} />;
      case 'shotcut':
        return <Icons.IconShortcut className={`icon icon--${size}`} />;
      case 'tag-line':
        return <Icons.IconTagLine className={`icon icon--${size}`} />;
      case 'tiktok':
        return <Icons.IconTiktok className={`icon icon--${size}`} />;
      case 'twitter':
        return <Icons.IconTwitter className={`icon icon--${size}`} />;
      case 'ukrajine':
        return <Icons.IconUkrajine className={`icon icon--${size}`} />;
      case 'user':
        return <Icons.IconUser className={`icon icon--${size}`} />;
      case 'warning':
        return <Icons.IconWarning className={`icon icon--${size}`} />;
      case 'windows':
        return <Icons.IconWindows className={`icon icon--${size}`} />;
      case 'youtube':
        return <Icons.IconYoutube className={`icon icon--${size}`} />;
      case 'arrow-down-left':
        return <Icons.IconArrowDownLeft className={`icon icon--${size}`} />;
      case 'arrow-down':
        return <Icons.IconArrowDown className={`icon icon--${size}`} />;
      case 'arrow-left':
        return <Icons.IconArrowLeft className={`icon icon--${size}`} />;
      case 'arrow-right':
        return <Icons.IconArrowRight className={`icon icon--${size}`} />;
      case 'arrow-up-left':
        return <Icons.IconArrowUpLeft className={`icon icon--${size}`} />;
      case 'arrow-up-right':
        return <Icons.IconArrowUpRight className={`icon icon--${size}`} />;
      case 'arrow-up':
        return <Icons.IconArrowUp className={`icon icon--${size}`} />;
      case 'be-better':
        return <Icons.IconBeBetter className={`icon icon--${size}`} />;
      case 'billionaires':
        return <Icons.IconBillionaires className={`icon icon--${size}`} />;
      case 'breaking-news':
        return <Icons.IconBreakingNews className={`icon icon--${size}`} />;
      case 'chevron-down':
        return <Icons.IconChevronDown className={`icon icon--${size}`} />;
      case 'chevron-left':
        return <Icons.IconChevronLeft className={`icon icon--${size}`} />;
      case 'chevron-right':
        return <Icons.IconChevronRight className={`icon icon--${size}`} />;
      case 'chevron-up':
        return <Icons.IconChevronUp className={`icon icon--${size}`} />;
      case 'cz-business':
        return <Icons.IconCzBusiness className={`icon icon--${size}`} />;
      case 'gastro':
        return <Icons.IconGastro className={`icon icon--${size}`} />;
      case 'individual':
        return <Icons.IconIndividual className={`icon icon--${size}`} />;
      case 'life':
        return <Icons.IconLife className={`icon icon--${size}`} />;
      case 'link-arrow-left':
        return <Icons.IconLinkArrowLeft className={`icon icon--${size}`} />;
      case 'link-arrow-right':
        return <Icons.IconLinkArrowRight className={`icon icon--${size}`} />;
      case 'lovebrand':
        return <Icons.IconLovebrand className={`icon icon--${size}`} />;
      case 'loyalty':
        return <Icons.IconLoyalty className={`icon icon--${size}`} />;
      case 'nav-arrow-left':
        return <Icons.IconNavArrowLeft className={`icon icon--${size}`} />;
      case 'nav-arrow-right':
        return <Icons.IconNavArrowRight className={`icon icon--${size}`} />;
      case 'rectangle-chevron-left':
        return <Icons.IconRectangleChevronLeft className={`icon icon--${size}`} />;
      case 'rectangle-chevron-right':
        return <Icons.IconRectangleChevronRight className={`icon icon--${size}`} />;
      case 'rectangle-chevron-up':
        return <Icons.IconRectangleChevronUp className={`icon icon--${size}`} />;
      case 'target':
        return <Icons.IconTarget className={`icon icon--${size}`} />;
      case 'travel':
        return <Icons.IconTravel className={`icon icon--${size}`} />;
      case 'woman':
        return <Icons.IconWoman className={`icon icon--${size}`} />;
      case 'world-business':
        return <Icons.IconWorldBusiness className={`icon icon--${size}`} />;
      case 'default-avatar':
        return <Icons.IconDefaultAvatar className={`icon icon--${size}`} />;
      case 'error':
        return <Icons.IconError className={`icon icon--${size}`} />;
      case 'diamond':
        return <Icons.IconDiamond className={`icon icon--${size}`} />;
      case 'success':
        return <Icons.IconSuccess className={`icon icon--${size}`} />;
      case 'forbes-f-logo':
        return <Icons.IconF className={`icon icon--${size}`} />;
      case 'f-circle':
        return <Icons.IconFCircle className={`icon icon--${size}`} />;
      case 'topic-hashtag':
        return <Icons.IconHashtagTopic className={`icon icon--${size}`} />;
      case 'filter':
        return <Icons.IconFilter className={`icon icon--${size}`} />;
      case 'ecom-arrow-down':
        return <Icons.IconEcomArrowDown className={`icon icon--${size}`} />;
      case 'ecom-arrow-up':
        return <Icons.IconEcomArrowUp className={`icon icon--${size}`} />;
      case 'ecom-checkmark':
        return <Icons.IconEcomCheckmark className={`icon icon--${size}`} />;
      case 'ecom-chevron-down':
        return <Icons.IconEcomChevronDown className={`icon icon--${size}`} />;
      case 'ecom-chevron-right':
        return <Icons.IconEcomChevronRight className={`icon icon--${size}`} />;
      case 'ecom-chevron-left':
        return <Icons.IconEcomChevronLeft className={`icon icon--${size}`} />;
      default:
        return null;
    }
  };

  const IconComponent = getIconComponent();

  return IconComponent ? <div className="icon-wrapper">{IconComponent}</div> : null;
};

export default Icon;
